// src/utils/youtube.js
//
// Helpere pentru videoclipurile recomandate (YouTube): extragerea id-ului din
// orice formă de link, adresele de vizionare, de embed și de thumbnail.

export const YOUTUBE_ID_RE = /^[A-Za-z0-9_-]{11}$/;

export function parseYoutubeId(input) {
   const raw = String(input || "").trim();
   if (!raw) return "";
   if (YOUTUBE_ID_RE.test(raw)) return raw;

   let normalized = raw;
   if (!/^https?:\/\//i.test(normalized)) normalized = `https://${normalized}`;

   let url;
   try {
      url = new URL(normalized);
   } catch {
      return "";
   }

   const host = String(url.hostname || "")
      .replace(/^www\./i, "")
      .toLowerCase();

   if (host === "youtu.be") {
      const id = String(url.pathname || "")
         .split("/")
         .filter(Boolean)[0];
      return YOUTUBE_ID_RE.test(id) ? id : "";
   }

   if (
      host === "youtube.com" ||
      host.endsWith(".youtube.com") ||
      host === "youtube-nocookie.com" ||
      host.endsWith(".youtube-nocookie.com")
   ) {
      const fromQuery = String(url.searchParams.get("v") || "").trim();
      if (YOUTUBE_ID_RE.test(fromQuery)) return fromQuery;

      const parts = String(url.pathname || "")
         .split("/")
         .filter(Boolean);
      const markerIndex = parts.findIndex((segment) =>
         ["embed", "shorts", "live", "v"].includes(String(segment || "").toLowerCase()),
      );
      if (markerIndex >= 0) {
         const maybeId = String(parts[markerIndex + 1] || "").trim();
         if (YOUTUBE_ID_RE.test(maybeId)) return maybeId;
      }
   }

   return "";
}

export function youtubeWatchUrl(youtubeId) {
   return `https://www.youtube.com/watch?v=${encodeURIComponent(youtubeId)}`;
}

/** Player încorporat, fără cookie-uri de urmărire până la redare. */
export function youtubeEmbedUrl(youtubeId, { autoplay = false } = {}) {
   const params = new URLSearchParams({ rel: "0", modestbranding: "1" });
   if (autoplay) params.set("autoplay", "1");
   return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(
      youtubeId,
   )}?${params.toString()}`;
}

export function youtubeThumbnailUrl(youtubeId, quality = "hqdefault") {
   return `https://i.ytimg.com/vi/${encodeURIComponent(youtubeId)}/${quality}.jpg`;
}

/** Un videoclip din API (`{ id, title, youtubeUrl }`) în forma afișată. */
export function mapRecommendedVideo(raw, index = 0) {
   if (!raw || typeof raw !== "object") return null;

   const sourceUrl = raw.youtubeUrl || raw.url || raw.link || raw.youtube || "";
   const youtubeId = parseYoutubeId(sourceUrl);
   if (!youtubeId) return null;

   const fallbackTitle = `Material video ${String(index + 1).padStart(2, "0")}`;
   return {
      id: raw.id ?? raw._id ?? `video-${youtubeId}-${index + 1}`,
      youtubeId,
      title: String(raw.title || raw.name || "").trim() || fallbackTitle,
      watchUrl: youtubeWatchUrl(youtubeId),
      thumbnailUrl: youtubeThumbnailUrl(youtubeId),
      createdAt: raw.createdAt || raw.created_at || null,
   };
}
